export function BulletItem(props) {
    return (<li className="my-4 flex items-center m-1 justify-center">
			<div style={{ borderColor: props.color, backgroundColor: props.color }} className="m-4 ml-0 content p-[3px] border bg-clip-content rounded-full w-8 h-8 shrink-0"/>
			<div className="text-base">
				{props.children}
			</div>
		</li>);
}
